import React, { createContext, ReactNode } from "react";
import { TransactionsApi } from "../../api-client";
import useStore from "../../helpers/useStore";
import { AuthContext } from "../Auth/auth.provider";
import { createApiConfig } from "../../api/createApiConfig";
import { observer, useLocalObservable } from "mobx-react";
import TransactionsStore from "./TransactionsStore";

interface TransactionsProviderProps {
  children: ReactNode;
}

export const TransactionsContext = createContext<TransactionsStore | null>(null);
TransactionsContext.displayName = "TransactionsContext";

export const TransactionsProvider = observer(({ children }: TransactionsProviderProps) => {
  const AuthenticationStore = useStore(AuthContext);

  const apiClient = new TransactionsApi(createApiConfig());
  const store = useLocalObservable(() => new TransactionsStore(apiClient, AuthenticationStore));

  return <TransactionsContext.Provider value={store}>{children}</TransactionsContext.Provider>;
});
